import React from 'react';
import './ActivityType.css';

export const ACTIVITY_TYPES = [
  { value:'task', label:'Task' },
  { value:'procurement', label:'Procurement' },
  { value:'assembly', label:'Assembly' },
];
export function activityType(value) {
  return ACTIVITY_TYPES.some(type => type.value === value) ? value : 'task';
}
export function isCampaignPlan(task) {
  return !task.parent_task_id && !!task.children?.length;
}
export function taskBoardRecords(tasks) {
  return tasks.flatMap(task => isCampaignPlan(task)
    ? task.children.map(child => ({ ...child, _parentTitle: task.title }))
    : [{ ...task, _parentTitle:null }]);
}
export function PlanTag() {
  return <span className="activity-type-tag activity-type-plan">Plan</span>;
}
export function matchesActivityType(task, filter) {
  return filter === 'all' || activityType(task.activity_type) === filter;
}
// Keep the original parent object so filtering never changes its cost roll-up
// or the edit modal's knowledge of children. Filter only the displayed rows.
export function filterActivityGroups(tasks, filter) {
  return tasks.map(task => ({ task,
    children:(task.children || []).filter(child => matchesActivityType(child, filter)),
    contextOnly:isCampaignPlan(task) || !matchesActivityType(task, filter),
  })).filter(group => !group.contextOnly || group.children.length > 0);
}
export function ActivityTypeTag({ value }) {
  const type = ACTIVITY_TYPES.find(item => item.value === activityType(value));
  return <span className={'activity-type-tag activity-type-' + type.value}>{type.label}</span>;
}
export function ActivityTypeFilter({ value, onChange, count, total }) {
  return <div className="activity-type-toolbar">
    <label>Task type <select value={value} onChange={event => onChange(event.target.value)}>
      <option value="all">All types</option>
      {ACTIVITY_TYPES.map(type => <option key={type.value} value={type.value}>{type.label}</option>)}
    </select></label>
    <span role="status">{count} of {total} tasks</span>
    {value !== 'all' && <button type="button" className="btn btn-sm" onClick={() => onChange('all')}>Clear filter</button>}
  </div>;
}
export function ActivityTypeSelect({ value, onChange }) {
  return <div className="field"><label>Task type
    <select value={value} onChange={event => onChange(event.target.value)}>
      {ACTIVITY_TYPES.map(type => <option key={type.value} value={type.value}>{type.label}</option>)}
    </select>
  </label><div className="activity-type-help">Group related work so it is easier to find and follow.</div></div>;
}
